import { Injectable } from '@angular/core';


export type Position = [number, number];


@Injectable({
    providedIn: 'root',
})
export class HighlightService {

    highlight(text: string, keyword: string, highlightTag = 'strong') {
        // extract tokens from keyword (escape special values for regexp, split & filter)
        const tokens = keyword
            .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            .split(' ')
            .filter(i => i !== '');
        const reg = new RegExp(`${tokens.join('|')}`, 'gi');
        text = text?.replace(reg, match => {
            if (match.length > 0) {
                return `<${highlightTag}>${match}</${highlightTag}>`;
            } else {
                return '';
            }
        });

        return text;
    }

    fuzzySearch(needle: string, haystack: string): Position[] {
        const haystackLowerCase = haystack.toLowerCase();
        let n = -1;
        const groups: Position[] = [];
        for (const letter of needle) {
            // for every char in needle check if char occur in haystack on > "latest position"
            n = haystackLowerCase.indexOf(letter.toLowerCase(), n + 1);
            if (n === -1) {
                // if not - no match
                return [];
            }
            if (groups.length === 0 || groups[0][1] < n) {
                groups.unshift([n, n + 1]);
            } else {
                groups[0][1]++;
            }
        }
        return groups;
    }

    highlightSearch(text: string, search: Position[], tag = 'strong') {
        for (const group of search) {
            const [start, end] = group;
            text = `${text.substring(0, start)}<${tag}>${text.substring(start, end)}</${tag}>${text.substring(end)}`;
        }
        return text;
    }
}
